__turbopack_context__.v({
  "controlsRow": "articlesTileHeader-module-scss-module__2xDNxa__controlsRow",
});
